import CommonModal from 'components/common/CommonModal';
import ScreenLayout from 'components/common/ScreenLayout';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import Pagination from 'components/common/Pagination';
import moment from 'moment-timezone';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {localeState, userInfoState} from 'utils/Atoms';
import {searchBackOfficeApprovalRequestTongPlace} from 'function/api';
import {convertTotalPage} from 'function/converter';
import {changeLocaleType, formatPhoneNumber} from 'utils/fomatPhoneNumber';
import {CountryCode} from 'libphonenumber-js';
import BusinessImgModal from 'components/main/BusinessImgModal';
import {allowStateStatus} from 'data/status';
import ChangeStateModal from 'components/main/ChangeStateModal';
import ContainerHeader from 'components/common/ContainerHeader';

/**
 * 현장 생성 요청 페이지 컴포넌트
 * 현장 생성 요청 목록을 조회하고 관리하는 페이지입니다.
 * @returns {JSX.Element} 현장 생성 요청 페이지 컴포넌트
 */
const OnSiteCreationRequest = () => {
  // locale
  const locale = useRecoilValue(localeState);
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});

  const navigate = useNavigate();

  const userInfo = useRecoilValue(userInfoState);

  const [requestTongCurrentPage, setRequestTongCurrentPage] = useState(1);
  const [requestTongTotalPage, setRequestTongTotalPage] = useState(1);

  const [requestTongData, setRequestTongData] = useState<null | any>(null);

  const [modal, setModal] = useState('');

  const [selectItem, setSelectItem] = useState<null | any>(null);

  const modalData: {[key: string]: any} = {
    // 본사시스템 서비스 준비중
    servicePreparing: {
      title: 'servicePreparing',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
      },
    },
  };

  useEffect(() => {
    if (!userInfo?.accessToken) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    if (userInfo?.accessToken) {
      searchBackOfficeApprovalRequestTongPlace({
        userInfo,
        setErrorModal,
        setIsLoading,
        page: requestTongCurrentPage,
      }).then(result => {
        if (result) {
          setRequestTongData(result);

          const resTotalPage = convertTotalPage(result.count ?? 0, 10);
          setRequestTongTotalPage(resTotalPage);
        }
      });
    }
  }, [userInfo, requestTongCurrentPage]);

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader
          mainTitle="fieldManagement"
          subTitle="onSiteCreationRequest"
        />

        <Inner>
          {/* 현장 생생 요청 */}
          <DefaultText
            text="현장 생성 요청 리스트"
            textStyle={{
              fontSize: minmax(25),
              fontWeight: 'bold',
              borderBottom: `3px solid ${colors.primary}`,
              width: 'fit-content',
              marginBottom: minmax(20),
            }}
          />
          <ResultArea>
            <ResultHeader>
              <DefaultText
                text=""
                textStyle={{
                  ...ResultHeaderTextStyle,
                  flex: 0.4,
                }}
              />
              <DefaultText
                text="applicationDate"
                textStyle={ResultHeaderTextStyle}
              />
              <DefaultText text="applicant" textStyle={ResultHeaderTextStyle} />
              <DefaultText
                text="applicantNumber"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="constructionCompanyName"
                textStyle={ResultHeaderTextStyle}
              />
              <DefaultText
                text="placeClassification"
                textStyle={{...ResultHeaderTextStyle, flex: 0.8}}
              />
              <DefaultText
                text="siteName"
                textStyle={{...ResultHeaderTextStyle, flex: 2}}
              />
              <DefaultText
                text="siteAddress"
                textStyle={{...ResultHeaderTextStyle, flex: 2}}
              />
              <DefaultText
                text="constructionPeriod"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="onsitePhoneNumber"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText text="state" textStyle={ResultHeaderTextStyle} />
            </ResultHeader>

            <ResultList>
              {requestTongData?.count ? (
                requestTongData.createTongPlaceTransactions.map(
                  (item: any, index: number) => (
                    <ResultItem
                      key={item.uuid}
                      onClick={() => {
                        //
                      }}>
                      <DefaultText
                        text={(
                          (requestTongCurrentPage - 1) * 10 +
                          index +
                          1
                        ).toString()}
                        textStyle={{...ResultHeaderTextStyle, flex: 0.4}}
                      />
                      <DefaultText
                        text={moment(item.createdAt).format('YY-MM-DD')}
                        textStyle={ResultItemStyle}
                      />
                      <DefaultText
                        text={item.requesterProfile.name || '-'}
                        textStyle={ResultItemStyle}
                      />
                      <DefaultText
                        text={
                          item.requesterProfile.phone
                            ? formatPhoneNumber({
                                phone: item.requesterProfile.phone,
                                locale: item.requesterProfile.locale,
                              })
                            : '-'
                        }
                        textStyle={{...ResultItemStyle, flex: 1.5}}
                      />
                      <DefaultText
                        text={item.createParams.contractorName}
                        textStyle={ResultItemStyle}
                      />
                      <DefaultText
                        text={item.createParams.placeClassification}
                        textStyle={{...ResultItemStyle, flex: 0.8}}
                      />
                      <DefaultText
                        text={item.createParams.name}
                        textStyle={{...ResultItemStyle, flex: 2}}
                      />
                      <DefaultText
                        text={
                          item.createParams.address +
                          (item.createParams.addressDetail
                            ? ', ' + item.createParams.addressDetail
                            : '')
                        }
                        textStyle={{...ResultItemStyle, flex: 2}}
                      />
                      <DefaultText
                        text={`${moment(
                          item.createParams.constructionStartDate,
                        ).format('YY-MM-DD')} ~ ${moment(
                          item.createParams.constructionEndDate,
                        ).format('YY-MM-DD')}`}
                        textStyle={{...ResultItemStyle, flex: 1.5}}
                      />
                      <DefaultText
                        text={formatPhoneNumber({
                          phone: item.createParams.tongPlaceNumber,
                          locale: item.createParams.locale,
                        })}
                        textStyle={{...ResultItemStyle, flex: 1.5}}
                      />
                      <DefaultText
                        text={allowStateStatus[item.allowState].text}
                        textStyle={{
                          ...ResultItemStyle,
                          color: allowStateStatus[item.allowState].color,
                          cursor:
                            item.createParams.placeClassification ===
                            'INITIAL_CONTRACTOR'
                              ? 'pointer'
                              : 'default',
                          textDecoration:
                            item.createParams.placeClassification ===
                            'INITIAL_CONTRACTOR'
                              ? 'underline'
                              : 'default',
                        }}
                        onClick={() =>
                          item.createParams.placeClassification ===
                            'INITIAL_CONTRACTOR' &&
                          setSelectItem({
                            ...item,
                            type: 'requestApproval',
                            isState: true,
                          })
                        }
                      />
                    </ResultItem>
                  ),
                )
              ) : (
                <DefaultText
                  text="noDataMsgTongList"
                  textStyle={{
                    color: colors.darkGray,
                    textAlign: 'center',
                    margin: `${minmax(12)} 0`,
                  }}
                />
              )}
            </ResultList>
          </ResultArea>

          {requestTongData?.count ? (
            <Pagination
              totalPage={requestTongTotalPage}
              currentPage={requestTongCurrentPage}
              setCurrentPage={setRequestTongCurrentPage}
            />
          ) : null}
        </Inner>
      </Container>

      {modal !== '' && (
        <CommonModal
          title={modalData[modal].title}
          detail={modalData[modal].detail}
          firstButtonText={modalData[modal].firstButtonText}
          firstButtonStyle={modalData[modal].firstButtonStyle}
          secondButtonText={modalData[modal].secondButtonText}
          secondButtonStyle={modalData[modal].secondButtonStyle}
          firstButtonClick={modalData[modal].firstButtonClick}
          secondButtonClick={modalData[modal].secondButtonClick}
          closeModal={modalData[modal].firstButtonClick}
        />
      )}

      {/* 상태 변경 | 사업자등록증 모달 */}
      {selectItem &&
        (selectItem.isState ? (
          <ChangeStateModal
            selectItem={selectItem}
            closeModal={() => setSelectItem(null)}
            setIsLoading={setIsLoading}
            setErrorModal={setErrorModal}
          />
        ) : (
          <BusinessImgModal
            selectItem={selectItem}
            closeModal={() => setSelectItem(null)}
            setIsLoading={setIsLoading}
            setErrorModal={setErrorModal}
          />
        ))}
    </ScreenLayout>
  );
};

export default OnSiteCreationRequest;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(20)};
`;

const ResultArea = styled.div`
  margin-bottom: ${minmax(40)};
  border-bottom: 1px solid ${colors.darkGray};
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultList = styled.ul`
  /* height: 728px; */
  /* overflow-y: auto; */

  // 스크롤바 삭제
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const ResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${minmax(8)} 0;
  min-height: ${minmax(52)};
  border-top: 1px solid ${colors.lightGrey};
  &:last-child {
    border-bottom: none;
  }
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  // whiteSpace: 'nowrap',
  // wordBreak: 'break-all',
};
